<template>
  <div>
    <auto-logout />
    <v-toolbar dark :src="require('@/assets/core/alleenlijn.jpg')">
      <v-toolbar-title  @click="goHome" class="ml-15">Trusted Accountant</v-toolbar-title>
      <v-btn class="ml-10" outlined @click="goHome">Home</v-btn>
      <div class="ml-5">Welkom {{authUser.first_name_user}} {{authUser.last_name_user}}</div>
      <v-spacer></v-spacer>
      <v-btn icon @click="toggle_dark_mode">
        <v-icon>mdi-theme-light-dark</v-icon>
      </v-btn>
      <v-btn outlined @click="logout">Logout</v-btn>
<!--      <v-col ma-6 lg="2" md="3" sm="4" cols="5">-->
<!--        <v-select-->
<!--          v-model="$i18n.locale"-->
<!--          :items="items"-->
<!--          item-text="lang"-->
<!--          item-value="abbr"-->
<!--          label="Select"-->
<!--          single-line-->
<!--          class="fit"-->
<!--        ></v-select>-->
<!--      </v-col>-->
    </v-toolbar>
    <succes />
    <ClipSucces />
    <ClipProblem />
    <inv-suc />
    <inv-problem />
    <Print />
    <error />

  </div>
</template>

<script>

import Succes from "@/components/Alerts/succes";
import Print from "@/components/Alerts/print"
import Error from "@/components/Alerts/error";
import ClipSucces from "@/components/Alerts/clipSuc"
import ClipProblem from "@/components/Alerts/clipProbl"
import { mapGetters } from "vuex";
import InvSuc from "@/components/Alerts/invSuc";
import InvProblem from "@/components/Alerts/invProblem";
import autoLogout from "@/components/AutoLogout";
export default {
  // eslint-disable-next-line vue/no-unused-components
  name: "Toolbar", components: { InvProblem, InvSuc, Error, Succes, Print, ClipSucces, ClipProblem, autoLogout}, data() {
    return {
      theme: null,
      items: [
        { lang: "English", abbr: "en" },
        { lang: "Nederlands", abbr: "nl" },
      ],
    };
  },
  methods: {
    toggle_dark_mode: function () {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      localStorage.setItem("dark_theme", this.$vuetify.theme.dark.toString());
    },
    logout() {
      this.$store.dispatch("auth/logout");
    },
    goHome(){
      this.$router.push({ name: "dashboard" });
    }
  },
  computed: {
    ...mapGetters("auth", ["authUser", "isAdmin", "isSuper"]),
  },

  mounted() {
    const theme = localStorage.getItem("dark_theme");
    if (theme) {
      this.$vuetify.theme.dark = theme === "true";
    }
  },
};
</script>
<style scoped></style>
